export default __webpack_public_path__ + "static/media/FABIA_Samuel_FOUGUE.e1a37bac.jpg";